// extracted by mini-css-extract-plugin
export var chatHtmlText = "_t9-2";
export var chatLink = "_t9-0";
export var chatText = "_t9-1";